// Promise helper: resolves to [data, null] or [null, error]
// Usage: const [result, err] = await to(somePromise)
export const to = promise =>
  promise.then(data => [data, null]).catch(err => [null, err]);

// Returns true if the API response indicates a failure
export const checkRequestFailure = ({ body, response } = {}) =>
  !body || !!body.errors || !response || response.status !== 200;
